import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CheckIcon, XIcon, AlertCircleIcon, ShieldIcon, FileTextIcon, BuildingIcon, CheckCircleIcon, InfoIcon, ClockIcon } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
const DigitalAdvisorView = () => {
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleSendToRatingAgency = () => {
    setShowConfirmation(true);
  };
  const handleConfirmationClose = () => {
    navigate('/demo/advisor-assessment');
  };
  if (showConfirmation) {
    return <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4" data-id="element-193">
        <div className="w-full max-w-md" data-id="element-194">
          <Card data-id="element-195">
            <div className="text-center mb-6" data-id="element-196">
              <div className="flex justify-center mb-4" data-id="element-197">
                <div className="w-16 h-16 rounded-full bg-success bg-opacity-10 flex items-center justify-center" data-id="element-198">
                  <CheckCircleIcon className="w-8 h-8 text-success" data-id="element-199" />
                </div>
              </div>
              <h2 className="text-xl font-bold text-success" data-id="element-200">
                Application Sent Successfully!
              </h2>
              <p className="text-neutral-500 mt-2" data-id="element-201">
                The micro-sukuk application has been sent to the Rating Agency
                for assessment.
              </p>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg mb-6" data-id="element-202">
              <h3 className="font-medium mb-2" data-id="element-203">Next Steps</h3>
              <ol className="space-y-3 text-sm" data-id="element-204">
                <li className="flex items-start" data-id="element-205">
                  <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-206">
                    <span className="text-white text-xs" data-id="element-207">1</span>
                  </div>
                  <div data-id="element-208">
                    <span className="font-medium" data-id="element-209">Rating Assessment</span>
                    <p className="text-neutral-500" data-id="element-210">
                      The Rating Agency will evaluate the application for risk
                      rating.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-211">
                  <div className="w-6 h-6 rounded-full bg-neutral-200 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-212">
                    <span className="text-neutral-600 text-xs" data-id="element-213">2</span>
                  </div>
                  <div data-id="element-214">
                    <span className="font-medium" data-id="element-215">
                      Shariah Compliance Review
                    </span>
                    <p className="text-neutral-500" data-id="element-216">
                      Shariah advisors will verify compliance.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-217">
                  <div className="w-6 h-6 rounded-full bg-neutral-200 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-218">
                    <span className="text-neutral-600 text-xs" data-id="element-219">3</span>
                  </div>
                  <div data-id="element-220">
                    <span className="font-medium" data-id="element-221">Contract Signing</span>
                    <p className="text-neutral-500" data-id="element-222">
                      MSME will sign the micro-sukuk contract.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
            <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4 mb-6" data-id="element-223">
              <div className="flex items-center" data-id="element-224">
                <InfoIcon className="w-5 h-5 text-primary mr-2 flex-shrink-0" data-id="element-225" />
                <p className="text-sm" data-id="element-226">
                  You'll be notified when the Rating Agency completes their
                  assessment. The rating process typically takes 2-3 business
                  days.
                </p>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-227">
              <Button variant="primary" onClick={handleConfirmationClose} data-id="element-228">
                Return to Dashboard
              </Button>
            </div>
          </Card>
        </div>
      </div>;
  }
  return <div className="max-w-4xl mx-auto" data-id="element-229">
      <div className="mb-6" data-id="element-230">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-231">
          Digital Advisor Assessment
        </h1>
        <p className="text-neutral-400" data-id="element-232">
          Initial review of micro-sukuk application before sending to Rating
          Agency
        </p>
      </div>
      {/* Listing Pipeline Progress */}
      <section className="mb-8" data-id="element-233">
        <div className="bg-white border border-neutral-100 rounded-lg p-6" data-id="element-234">
          <div className="relative mb-8" data-id="element-235">
            {/* Pipeline Progress Bar */}
            <div className="absolute top-4 left-0 right-0 h-1 bg-neutral-200" data-id="element-236">
              <div className="bg-primary h-1" style={{
              width: '40%'
            }} data-id="element-237"></div>
            </div>
            {/* Pipeline Stages */}
            <div className="flex justify-between relative" data-id="element-238">
              {/* Stage 1: MSME Initiation */}
              <div className="flex flex-col items-center w-1/6" data-id="element-239">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-240">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-241" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-242">
                  MSME Initiation
                </div>
                <div className="text-xs text-success text-center" data-id="element-243">
                  Completed
                </div>
              </div>
              {/* Stage 2: Digital Advisor */}
              <div className="flex flex-col items-center w-1/6" data-id="element-244">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-245">
                  <ClockIcon className="w-4 h-4 text-white" data-id="element-246" />
                </div>
                <div className="text-xs font-medium text-center text-primary" data-id="element-247">
                  Digital Advisor
                </div>
                <div className="text-xs text-primary text-center" data-id="element-248">
                  In Progress
                </div>
              </div>
              {/* Stage 3: Rating Agency */}
              <div className="flex flex-col items-center w-1/6" data-id="element-249">
                <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center z-10 mb-2" data-id="element-250">
                  <span className="text-neutral-400 text-sm" data-id="element-251">3</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-252">
                  Rating Agency
                </div>
                <div className="text-xs text-neutral-400 text-center" data-id="element-253">
                  Pending
                </div>
              </div>
              {/* Stage 4: Shariah Review */}
              <div className="flex flex-col items-center w-1/6" data-id="element-254">
                <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center z-10 mb-2" data-id="element-255">
                  <span className="text-neutral-400 text-sm" data-id="element-256">4</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-257">
                  Shariah Review
                </div>
                <div className="text-xs text-neutral-400 text-center" data-id="element-258">
                  Pending
                </div>
              </div>
              {/* Stage 5: Contract Signing */}
              <div className="flex flex-col items-center w-1/6" data-id="element-259">
                <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center z-10 mb-2" data-id="element-260">
                  <span className="text-neutral-400 text-sm" data-id="element-261">5</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-262">
                  Contract Signing
                </div>
                <div className="text-xs text-neutral-400 text-center" data-id="element-263">
                  Pending
                </div>
              </div>
              {/* Stage 6: Marketplace */}
              <div className="flex flex-col items-center w-1/6" data-id="element-264">
                <div className="w-8 h-8 rounded-full bg-neutral-100 flex items-center justify-center z-10 mb-2" data-id="element-265">
                  <span className="text-neutral-400 text-sm" data-id="element-266">6</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-267">
                  Marketplace
                </div>
                <div className="text-xs text-neutral-400 text-center" data-id="element-268">
                  Pending
                </div>
              </div>
            </div>
          </div>
          <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4" data-id="element-269">
            <div className="flex items-center mb-2" data-id="element-270">
              <ClockIcon className="w-5 h-5 text-primary mr-2" data-id="element-271" />
              <h4 className="font-medium text-primary" data-id="element-272">
                Current Stage: Digital Advisor Assessment
              </h4>
            </div>
            <p className="text-sm text-neutral-500" data-id="element-273">
              Digital Advisor is reviewing the application for completeness and
              eligibility before sending it to the Rating Agency. This process
              typically takes 1-2 business days.
            </p>
          </div>
        </div>
      </section>
      {/* Application Overview */}
      <section className="mb-8" data-id="element-274">
        <Card data-id="element-275">
          <div className="flex items-center mb-6" data-id="element-276">
            <div className="w-12 h-12 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-4" data-id="element-277">
              <FileTextIcon className="w-6 h-6 text-primary" data-id="element-278" />
            </div>
            <div data-id="element-279">
              <h3 className="font-bold text-lg" data-id="element-280">Application #MS2023-104</h3>
              <div className="flex items-center text-sm text-neutral-400" data-id="element-281">
                <span data-id="element-282">Amani Cafe</span>
                <span className="mx-2" data-id="element-283">•</span>
                <span data-id="element-284">Equipment Purchase</span>
                <span className="mx-2" data-id="element-285">•</span>
                <span data-id="element-286">RM 25,000</span>
              </div>
            </div>
            <div className="ml-auto bg-warning bg-opacity-10 text-warning px-3 py-1 rounded-full text-sm font-medium" data-id="element-287">
              Under Review
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-288">
            <div data-id="element-289">
              <h4 className="font-medium mb-3" data-id="element-290">Business Information</h4>
              <div className="space-y-3" data-id="element-291">
                <div className="flex justify-between" data-id="element-292">
                  <span className="text-sm text-neutral-400" data-id="element-293">
                    Business Name
                  </span>
                  <span className="text-sm font-medium" data-id="element-294">Amani Cafe</span>
                </div>
                <div className="flex justify-between" data-id="element-295">
                  <span className="text-sm text-neutral-400" data-id="element-296">
                    Registration No.
                  </span>
                  <span className="text-sm font-medium" data-id="element-297">BRN-1234567-A</span>
                </div>
                <div className="flex justify-between" data-id="element-298">
                  <span className="text-sm text-neutral-400" data-id="element-299">
                    Years in Operation
                  </span>
                  <span className="text-sm font-medium" data-id="element-300">3 years, 4 months</span>
                </div>
                <div className="flex justify-between" data-id="element-301">
                  <span className="text-sm text-neutral-400" data-id="element-302">
                    Monthly Revenue
                  </span>
                  <span className="text-sm font-medium" data-id="element-303">RM 45,000</span>
                </div>
                <div className="flex justify-between" data-id="element-304">
                  <span className="text-sm text-neutral-400" data-id="element-305">Credit Score</span>
                  <span className="text-sm font-medium text-success" data-id="element-306">
                    Excellent (85/100)
                  </span>
                </div>
              </div>
            </div>
            <div data-id="element-307">
              <h4 className="font-medium mb-3" data-id="element-308">Financing Request</h4>
              <div className="space-y-3" data-id="element-309">
                <div className="flex justify-between" data-id="element-310">
                  <span className="text-sm text-neutral-400" data-id="element-311">Purpose</span>
                  <span className="text-sm font-medium" data-id="element-312">
                    Equipment Purchase
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-313">
                  <span className="text-sm text-neutral-400" data-id="element-314">
                    Amount Requested
                  </span>
                  <span className="text-sm font-medium" data-id="element-315">RM 25,000</span>
                </div>
                <div className="flex justify-between" data-id="element-316">
                  <span className="text-sm text-neutral-400" data-id="element-317">Duration</span>
                  <span className="text-sm font-medium" data-id="element-318">6 months</span>
                </div>
                <div className="flex justify-between" data-id="element-319">
                  <span className="text-sm text-neutral-400" data-id="element-320">
                    Monthly Payment
                  </span>
                  <span className="text-sm font-medium" data-id="element-321">RM 4,271</span>
                </div>
                <div className="flex justify-between" data-id="element-322">
                  <span className="text-sm text-neutral-400" data-id="element-323">Total Profit</span>
                  <span className="text-sm font-medium" data-id="element-324">
                    RM 2,250 (18% p.a.)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Validation Checklist */}
      <section className="mb-8" data-id="element-325">
        <Card data-id="element-326">
          <h3 className="font-bold text-lg mb-4" data-id="element-327">Validation Checklist</h3>
          <div className="space-y-6" data-id="element-328">
            {/* Business Eligibility */}
            <div data-id="element-329">
              <div className="flex items-center mb-3" data-id="element-330">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-331">
                  <CheckCircleIcon className="w-4 h-4 text-success" data-id="element-332" />
                </div>
                <h4 className="font-medium" data-id="element-333">Business Eligibility</h4>
              </div>
              <div className="ml-11 space-y-2" data-id="element-334">
                <div className="flex items-center" data-id="element-335">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-336" />
                  <span className="text-sm" data-id="element-337">
                    Business age requirement met (3+ years)
                  </span>
                </div>
                <div className="flex items-center" data-id="element-338">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-339" />
                  <span className="text-sm" data-id="element-340">
                    Revenue threshold met (RM 45,000/month)
                  </span>
                </div>
                <div className="flex items-center" data-id="element-341">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-342" />
                  <span className="text-sm" data-id="element-343">
                    Credit history verified (No defaults)
                  </span>
                </div>
                <div className="flex items-center" data-id="element-344">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-345" />
                  <span className="text-sm" data-id="element-346">
                    Business registration verified
                  </span>
                </div>
              </div>
            </div>
            {/* Equipment Validation */}
            <div data-id="element-347">
              <div className="flex items-center mb-3" data-id="element-348">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-349">
                  <BuildingIcon className="w-4 h-4 text-success" data-id="element-350" />
                </div>
                <h4 className="font-medium" data-id="element-351">Equipment Validation</h4>
              </div>
              <div className="ml-11 space-y-2" data-id="element-352">
                <div className="flex items-center" data-id="element-353">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-354" />
                  <span className="text-sm" data-id="element-355">
                    Equipment aligns with business type
                  </span>
                </div>
                <div className="flex items-center" data-id="element-356">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-357" />
                  <span className="text-sm" data-id="element-358">
                    Quotation verified (RM 24,500)
                  </span>
                </div>
                <div className="flex items-center" data-id="element-359">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-360" />
                  <span className="text-sm" data-id="element-361">
                    Equipment is Shariah-compliant
                  </span>
                </div>
                <div className="flex items-center" data-id="element-362">
                  <AlertCircleIcon className="w-5 h-5 text-warning mr-2" data-id="element-363" />
                  <span className="text-sm" data-id="element-364">
                    Warranty documentation requested
                  </span>
                </div>
              </div>
            </div>
            {/* Vendor Verification */}
            <div data-id="element-365">
              <div className="flex items-center mb-3" data-id="element-366">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-367">
                  <CheckCircleIcon className="w-4 h-4 text-success" data-id="element-368" />
                </div>
                <h4 className="font-medium" data-id="element-369">Vendor Verification</h4>
              </div>
              <div className="ml-11 space-y-2" data-id="element-370">
                <div className="flex items-center" data-id="element-371">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-372" />
                  <span className="text-sm" data-id="element-373">Vendor is on approved list</span>
                </div>
                <div className="flex items-center" data-id="element-374">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-375" />
                  <span className="text-sm" data-id="element-376">Business license verified</span>
                </div>
                <div className="flex items-center" data-id="element-377">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-378" />
                  <span className="text-sm" data-id="element-379">Shariah compliance confirmed</span>
                </div>
                <div className="flex items-center" data-id="element-380">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-381" />
                  <span className="text-sm" data-id="element-382">
                    Delivery timeline confirmed (2 weeks)
                  </span>
                </div>
              </div>
            </div>
            {/* Business Impact Assessment */}
            <div data-id="element-383">
              <div className="flex items-center mb-3" data-id="element-384">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-385">
                  <CheckCircleIcon className="w-4 h-5 text-success" data-id="element-386" />
                </div>
                <h4 className="font-medium" data-id="element-387">Business Impact Assessment</h4>
              </div>
              <div className="ml-11 space-y-2" data-id="element-388">
                <div className="flex items-center" data-id="element-389">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-390" />
                  <span className="text-sm" data-id="element-391">Growth plan is realistic</span>
                </div>
                <div className="flex items-center" data-id="element-392">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-393" />
                  <span className="text-sm" data-id="element-394">Revenue projection validated</span>
                </div>
                <div className="flex items-center" data-id="element-395">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-396" />
                  <span className="text-sm" data-id="element-397">
                    Community benefits are appropriate
                  </span>
                </div>
                <div className="flex items-center" data-id="element-398">
                  <CheckIcon className="w-5 h-5 text-success mr-2" data-id="element-399" />
                  <span className="text-sm" data-id="element-400">Repayment capacity confirmed</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Final Assessment */}
      <section className="mb-8" data-id="element-401">
        <Card data-id="element-402">
          <h3 className="font-bold text-lg mb-4" data-id="element-403">Digital Advisor Assessment</h3>
          <div className="mb-6" data-id="element-404">
            <div className="flex items-center mb-3" data-id="element-405">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-406">
                <CheckCircleIcon className="w-5 h-5 text-success" data-id="element-407" />
              </div>
              <div data-id="element-408">
                <h4 className="font-medium" data-id="element-409">Application Completeness</h4>
                <p className="text-sm text-neutral-400" data-id="element-410">
                  Verification of required documentation and information
                </p>
              </div>
              <div className="ml-auto bg-success bg-opacity-10 text-success px-3 py-1 rounded-full text-sm font-medium" data-id="element-411">
                Complete
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg ml-13" data-id="element-412">
              <p className="text-sm mb-2" data-id="element-413">
                All required documentation has been submitted by Amani Cafe. The
                business information, financial data, and intended use of funds
                are clearly documented. The equipment purchase aligns with their
                business model.
              </p>
              <p className="text-sm font-medium text-success" data-id="element-414">
                Application is complete and ready for rating agency review.
              </p>
            </div>
          </div>
          <div className="mb-6" data-id="element-415">
            <div className="flex items-center mb-3" data-id="element-416">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-417">
                <CheckCircleIcon className="w-5 h-5 text-success" data-id="element-418" />
              </div>
              <div data-id="element-419">
                <h4 className="font-medium" data-id="element-420">Eligibility Check</h4>
                <p className="text-sm text-neutral-400" data-id="element-421">
                  Verification of business eligibility criteria
                </p>
              </div>
              <div className="ml-auto bg-success bg-opacity-10 text-success px-3 py-1 rounded-full text-sm font-medium" data-id="element-422">
                Eligible
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg ml-13" data-id="element-423">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3" data-id="element-424">
                <div data-id="element-425">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-426">
                    Business Age
                  </div>
                  <div className="font-medium" data-id="element-427">
                    3+ years (Required: 2+ years)
                  </div>
                </div>
                <div data-id="element-428">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-429">
                    Monthly Revenue
                  </div>
                  <div className="font-medium" data-id="element-430">
                    RM 45,000 (Required: RM 20,000+)
                  </div>
                </div>
                <div data-id="element-431">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-432">
                    Credit History
                  </div>
                  <div className="font-medium" data-id="element-433">
                    No defaults (Required: Clean record)
                  </div>
                </div>
                <div data-id="element-434">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-435">
                    Documentation
                  </div>
                  <div className="font-medium" data-id="element-436">
                    Complete (Business registration verified)
                  </div>
                </div>
              </div>
              <p className="text-sm font-medium text-success" data-id="element-437">
                Business meets all eligibility criteria for micro-sukuk
                issuance.
              </p>
            </div>
          </div>
          <div className="mb-6" data-id="element-438">
            <h4 className="font-medium mb-3" data-id="element-439">Advisor Notes</h4>
            <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" rows={3} defaultValue="Amani Cafe's application is complete and meets all eligibility criteria. The business has strong financials and the equipment purchase aligns with their growth strategy. The espresso machine will help increase revenue and the community benefits offered are appropriate. Recommend sending to rating agency for further assessment." data-id="element-440"></textarea>
          </div>
          <div className="flex flex-col sm:flex-row justify-end gap-3" data-id="element-441">
            <Button variant="outline" className="border-neutral-300 text-neutral-500" data-id="element-442">
              Request Additional Information
            </Button>
            <Button variant="primary" onClick={handleSendToRatingAgency} data-id="element-443">
              Send to Rating Agency
            </Button>
          </div>
        </Card>
      </section>
    </div>;
};
export default DigitalAdvisorView;